import { useEffect } from "react";
import { SITE_URL as SITE } from "@/routes/seo";

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.append(el);
  }
  el.content = value;
}

/** Client-side head management (prerendered pages already ship the same tags in static HTML). */
export function Seo({ title, description, path, noindex }: { title: string; description?: string; path?: string; noindex?: boolean }) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    if (path) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.append(link);
      }
      link.href = `${SITE}${path}`;
      setMeta("property", "og:url", `${SITE}${path}`);
    }
  }, [title, description, path, noindex]);
  return null;
}
